import React from "react";

type RadioButtonProps = {
  label: React.ReactNode;
  value: string | number;
  name: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
};

const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  value,
  name,
  checked,
  onChange,
  disabled = false,
  className = "",
}) => {
  const id = `${name}-${value}`;

  return (
    <label
      htmlFor={id}
      className={`radio-wrapper ${className} ${disabled ? "disabled" : ""}`}
    >
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="radio-mark"></span>
      <span className="radio-label">{label}</span>
    </label>
  );
};

export default RadioButton;
